import React, { useState } from "react";
import "../../styles/input-auto.css";



function InputAuto({  field,pholder,data,onSelected,onChange,className,minStart, maxResults=25,value }) {

  const [suggestions, setSugesstions] = useState([]);
  const [isHideSuggs, setIsHideSuggs] = useState(false);
  const [selectedVal, setSelectedVal] = useState("");

  const handler = e => {

    if(e.target.value.length>=minStart){
        const val = e.target.value.toUpperCase();

       
        var all_items = data?.filter(i => i[field]?.toUpperCase().startsWith(val));
        setSugesstions(all_items?.slice(0,maxResults));
    }
  };

  const handleChange = e => {
    const input = e.target.value;
    setIsHideSuggs(false);
    //setSelectedVal(input);
    onChange(input);
  };

  const hideSuggs = v => {
    onChange(v[field]);

    onSelected(v);
    setSelectedVal(v[field]);
    setIsHideSuggs(true);
  };

  const focusLeft = v => {
    
    setTimeout(() => {
      setIsHideSuggs(true);
    }, 400);
    
  
  };

  
  return (
    <div className="sugesstion-auto">
      <div >
        <input
          className={className}
          placeholder={pholder}
          type="search"
          value={value}
          onChange={handleChange}
          onKeyUp={handler}
          onBlur={focusLeft}
        />
      </div>
      <div className="suggestions" style={{ display: isHideSuggs ? "none" : "block" }}   >
        {suggestions?.map((item, idx) => (
          <div
            key={"" + item[field] + idx}
            onClick={() => {
              hideSuggs(item);
            }}
          >
            {item[field]}
          </div>
        ))}
      </div>
    </div>
  );
}


export default InputAuto;
